import { styled } from '@mui/material';
import type { TabsProps } from '@mui/material/Tabs';
import MuiTabs from '@mui/material/Tabs';
import { clsx } from 'clsx';
import type { FC } from 'react';

const StyledTabs = styled(MuiTabs)<TabsProps>(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,

  '&.MuiTabs-vertical': {
    borderBottom: 0,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

const Tabs: FC<TabsProps> = ({ className, ...rest }) => {
  const classes = clsx('mnt-tabs', className);

  return <StyledTabs {...rest} className={classes} />;
};
Tabs.displayName = 'Tabs';

export default Tabs;
export type { TabsProps };
